import { ArticleJsonLdProps } from 'next-seo'

import { Article, FilterBy } from './types'
import { getDynamicPath, pathMap } from '@/utils/pagesPath'

export const toArticle = (article: any): Article => {
  const { attributes } = article
  const src = attributes?.src?.data?.attributes?.url
  const fileName = attributes?.src?.data?.attributes?.name || ''
  const alt = attributes?.src?.data?.attributes?.alternativeText
  const tags = attributes?.tags?.data?.map((tag: any) => tag?.attributes?.value)
  const author = attributes?.author?.data?.attributes

  return {
    id: article?.id,
    title: attributes?.title,
    content: attributes?.content,
    excerpt: attributes?.excerpt,
    alt,
    src,
    fileName,
    tags,
    filterBy: attributes?.filterBy as FilterBy,
    publishedAt: attributes?.publishedAt,
    about: attributes?.about,
    slug: attributes?.slug,
    amountVisitors: Number(attributes?.amountVisitors || 0),
    author: {
      title: author?.title,
      name: author?.name,
      role: author?.role,
      avatar: author?.avatar?.data?.attributes?.url,
    },
    seo: {
      metaTitle:
        attributes?.seo?.metaTitle || `nata.house - ${attributes?.title}`,
      metaDescription:
        attributes?.seo?.metaDescription || attributes?.excerpt.slice(0, 150),
    },
  } as Article
}

export const toStructuredData = (article: Article) => {
  const structuredData: ArticleJsonLdProps = {
    useAppDir: false,
    url: `https://www.natahouse.com${getDynamicPath(
      pathMap.article,
      article.slug,
    )}`,
    title: article.title,
    images: [
      // TODO: VERIFY IF OTHER IMAGES ARE NEEDED
      article.src,
    ],
    datePublished: article.publishedAt,
    authorName: [
      {
        name: article.author?.name,
        url: article.author?.seoUrl
          ? article.author?.seoUrl
          : 'https://www.natahouse.com',
        type:
          article.author?.role && article.author?.role === 'Empresa'
            ? 'Organization'
            : 'Person',
      },
    ],
    publisherName: 'nata.house',
    description: article.about,
    isAccessibleForFree: true,
    keyOverride: article.title,
  }

  return structuredData
}
